import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

import {IGetDataArgs} from '../model/types';
import {
    IGetDataGroupCompanyResponse,
    IPostDataGroupCompanyArgs,
    IDeleteDataGroupCompanyArgs,
    IGroupCompanyDto,
    ITransfomedPutDataGroupCompanyArgs
} from './types';

const GROUP_INFO_ROUTE = 'integration.module/ais3.company.group.info/ais3.company.group.info.gc';

const getData = (args?: IGetDataArgs) =>
    performRequest<IGetDataGroupCompanyResponse>({
        url: GROUP_INFO_ROUTE,
        method: ERequestType.GET,
        params: {paginationPageSize: args?.paginationPageSize, paginationCurrent: args?.paginationCurrent},
    });

const getDataById = (id: number) =>
    performRequest<IGroupCompanyDto>({url: `${GROUP_INFO_ROUTE}/${id}`, method: ERequestType.GET});

const postData = (args: IPostDataGroupCompanyArgs) =>
    performRequest<string>({url: GROUP_INFO_ROUTE, data: args, method: ERequestType.POST});

const putData = (args: ITransfomedPutDataGroupCompanyArgs) =>
    performRequest<string>({url: `${GROUP_INFO_ROUTE}/${args.id}`, data: args, method: ERequestType.PUT});

const deleteData = (args: IDeleteDataGroupCompanyArgs) =>
    performRequest<string>({
        url: `${GROUP_INFO_ROUTE}/rpc/delete-list`,
        data: {ids: args.rowsIds},
        method: ERequestType.DELETE,
    });

export const groupCompanyApi = {getData, getDataById, postData, putData, deleteData};
